"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.59,14.19v2.4h-2.4v-2.4h2.4m.77-.77H13.42v3.94h3.94V13.42Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.23,14.19v2.4h-2.4v-2.4h2.4m.77-.77H20.06v3.94H24V13.42Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.61,20.83v2.4h-2.4v-2.4h2.4m.75-.77H13.42V24h3.94V20.06Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "18.25",
    y: "13.42",
    width: "0.92",
    height: "3.94"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "16.78",
    y: "18.72",
    width: "7.22",
    height: "0.89"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "13.42",
    y: "17.83",
    width: "1.87",
    height: "0.89"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "18.48",
    y: "20.92",
    width: "2.89",
    height: "0.89"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "23.08 20.92 23.08 23.08 20.05 23.08 20.05 24 24 24 24 23.99 24 23.08 24 20.92 23.08 20.92"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.17,12.59h5.39A7,7,0,0,0,15,8.68,3,3,0,0,0,9,8.68,7,7,0,0,0,5,15v4.5A1.53,1.53,0,0,1,3.49,21a.47.47,0,0,0-.48.48.48.48,0,0,0,.48.48H9.57A2.48,2.48,0,0,0,12,24a2.33,2.33,0,0,0,.59-.08V13.17A.58.58,0,0,1,13.17,12.59Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9,3A6,6,0,0,0,3,9a.48.48,0,0,0,.48.48A.49.49,0,0,0,4,9,5,5,0,0,1,9,4a.48.48,0,0,0,.48-.48A.47.47,0,0,0,9,3Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9,1A.47.47,0,0,0,9.47.48.47.47,0,0,0,9,0,9,9,0,0,0,0,9,.48.48,0,1,0,1,9,8,8,0,0,1,9,1Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15,4a5,5,0,0,1,5,5,.48.48,0,0,0,.48.48A.49.49,0,0,0,21,9a6,6,0,0,0-6-6,.47.47,0,0,0-.48.48A.48.48,0,0,0,15,4Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15,1a8,8,0,0,1,8,8,.48.48,0,1,0,1,0,9,9,0,0,0-9-9,.47.47,0,0,0-.48.48A.47.47,0,0,0,15,1Z"
  }));
};

exports["default"] = _default;